export const uk = {
    'phrases-caption': 'Фраз: {count}',
    'phrases-placeholder': 'Укажите фразы по одной на строку.'
};
